module.exports = __webpack_public_path__ + "assets/chevron-down-select.f90eaa15.svg";